(() => {
  const sliders = document.querySelectorAll('[data-offer-slider]');
  sliders.forEach((slider) => {
    const track = slider.querySelector('[data-offer-track]');
    const slides = [...slider.querySelectorAll('[data-offer-slide]')];
    const dots = [...slider.querySelectorAll('[data-offer-dot]')];
    if (!track || slides.length < 2) return;
    let index = 0;
    let startX = 0;
    let deltaX = 0;
    let dragging = false;
    let autoplay;
    const go = (next) => {
      index = (next + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', slideIndex !== index));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };
    const play = () => {
      window.clearInterval(autoplay);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) autoplay = window.setInterval(() => go(index + 1), 5200);
    };
    slider.querySelectorAll('[data-offer-next]').forEach((button) => button.addEventListener('click', () => { go(index + 1); play(); }));
    slider.querySelectorAll('[data-offer-prev]').forEach((button) => button.addEventListener('click', () => { go(index - 1); play(); }));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => { go(dotIndex); play(); }));
    slider.addEventListener('pointerdown', (event) => { if (event.button !== 0) return; dragging = true; startX = event.clientX; deltaX = 0; slider.classList.add('is-dragging'); window.clearInterval(autoplay); slider.setPointerCapture?.(event.pointerId); });
    slider.addEventListener('pointermove', (event) => { if (!dragging) return; deltaX = event.clientX - startX; });
    const finishDrag = () => { if (!dragging) return; if (Math.abs(deltaX) > Math.min(70, slider.clientWidth * .08)) go(index + (deltaX < 0 ? 1 : -1)); dragging = false; startX = 0; deltaX = 0; slider.classList.remove('is-dragging'); play(); };
    slider.addEventListener('pointerup', finishDrag);
    slider.addEventListener('pointercancel', finishDrag);
    slider.addEventListener('keydown', (event) => { if (event.key === 'ArrowRight') { go(index + 1); play(); } if (event.key === 'ArrowLeft') { go(index - 1); play(); } });
    go(0);
    play();
  });

  document.querySelectorAll('[data-deal-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-deal-track]');
    const dots = [...slider.querySelectorAll('[data-deal-dot]')];
    if (!track) return;
    const update = () => {
      const max = Math.max(1, track.scrollWidth - track.clientWidth);
      const active = track.scrollLeft / max > .35 ? 1 : 0;
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
    };
    slider.querySelector('[data-deal-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .78, behavior: 'smooth' }));
    slider.querySelector('[data-deal-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .78, behavior: 'smooth' }));
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => track.scrollTo({ left: dotIndex * (track.scrollWidth - track.clientWidth), behavior: 'smooth' })));
    track.addEventListener('scroll', update, { passive: true });
    update();
  });

  document.querySelectorAll('[data-product-filter]').forEach((button) => button.addEventListener('click', () => {
    const section = button.closest('.arv-product-range');
    const track = section?.querySelector('[data-deal-track]');
    if (!track) return;
    section.querySelectorAll('[data-product-filter]').forEach((tab) => tab.classList.toggle('is-active', tab === button));
    track.querySelectorAll('[data-product-card]').forEach((card) => { card.hidden = button.dataset.productFilter !== 'all' && card.dataset.productCategory !== button.dataset.productFilter; });
    track.scrollTo({ left: 0, behavior: 'smooth' });
  }));

  const horizontalRows = document.querySelectorAll('.featured-collection .product-grid, .arv-product-rail');
  horizontalRows.forEach((row) => {
    row.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const direction = event.key === 'ArrowRight' ? 1 : -1;
      row.scrollBy({ left: direction * row.clientWidth * 0.75, behavior: 'smooth' });
    });
  });

  const cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  const checkoutUrl = (window.routes && window.routes.root_url ? `${window.routes.root_url}checkout` : '/checkout');

  const addVariant = async (formData, renderCart) => {
    const cartSurface = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (renderCart && cartSurface?.getSectionsToRender) {
      const sections = cartSurface.getSectionsToRender().map((section) => section.id).filter(Boolean);
      if (sections.length) {
        formData.set('sections', sections.join(','));
        formData.set('sections_url', window.location.pathname);
      }
    }
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'This product could not be added.');
    if (renderCart && cartSurface?.renderContents && result.sections) cartSurface.renderContents(result);
    return result;
  };

  document.querySelectorAll('.arv-ajax-product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (!button || button.disabled) return;
      const originalLabel = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        await addVariant(new FormData(form), true);
        button.textContent = 'Added to cart';
      } catch (error) {
        button.textContent = error.message;
      } finally {
        button.removeAttribute('aria-busy');
        window.setTimeout(() => {
          button.textContent = originalLabel;
          button.disabled = false;
        }, 1600);
      }
    });
  });

  document.querySelectorAll('[data-arovia-buy-now]').forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.disabled || !button.dataset.variantId) return;
      const originalLabel = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Opening checkout…';
      const formData = new FormData();
      formData.set('id', button.dataset.variantId);
      formData.set('quantity', '1');
      try {
        await addVariant(formData, false);
        window.location.assign(checkoutUrl);
      } catch (error) {
        button.textContent = error.message;
        button.removeAttribute('aria-busy');
        window.setTimeout(() => {
          button.textContent = originalLabel;
          button.disabled = false;
        }, 1800);
      }
    });
  });

  const productButton = document.querySelector('.product-form__submit');
  if (!productButton || !document.querySelector('.product__info-container')) return;

  const priceText = document.querySelector('.product__info-container .price')?.textContent.trim() || '';
  const bar = document.createElement('div');
  bar.className = 'arv-mobile-buy-bar';
  bar.setAttribute('aria-label', 'Quick purchase');
  bar.innerHTML = `<span class="arv-mobile-buy-bar__price"><small>Current price</small><strong>${priceText}</strong></span><button class="arv-mobile-buy-bar__button" type="button">Add to cart</button>`;
  document.body.appendChild(bar);
  bar.querySelector('button').addEventListener('click', () => productButton.click());

  const observer = new IntersectionObserver(([entry]) => {
    bar.classList.toggle('is-visible', !entry.isIntersecting);
  }, { threshold: 0 });
  observer.observe(productButton);
})();
